const getQueryParams = <T>(searchParams: URLSearchParams, defaultObject: T): T => {
	const queryParams = structuredClone(defaultObject) as { [K in keyof T]: string | number };

	for (const key in defaultObject) {
		const params = searchParams.get(key);

		if (!params) continue;

		queryParams[key] = typeof defaultObject[key] === "string" ? params : Number(params);
	}

	return queryParams as T;
};

export default getQueryParams;
